import React from 'react'
import { paths } from '@mc/paths'
import { BaseLink, type BaseLinkProps } from '../BaseLink'

export const TermsLink = (props: BaseLinkProps) => (
  <BaseLink {...props} href={paths.terms} />
)
